module.exports = __webpack_public_path__ + "img/img0.325c74ef.jpg";